export enum ProductBadgeSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
}
